var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.loading,
            "action-collapse": "",
            title: _vm.$t("Configuração do Programa de Recompensas"),
          },
        },
        [
          _c(
            "FormulateForm",
            {
              ref: "rewardForm",
              attrs: { name: "rewardForm" },
              on: { submit: _vm.saveConfiguration },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "reward_config-is_active",
                          type: "switch",
                          label: _vm.$t("Sistema de recompensas ativo?"),
                        },
                        model: {
                          value: _vm.configuration.isActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.configuration, "isActive", $$v)
                          },
                          expression: "configuration.isActive",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.configuration.isActive
                    ? _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reward_config-is_RedemptionActive",
                              type: "switch",
                              label: _vm.$t("Resgate ativo?"),
                            },
                            model: {
                              value: _vm.configuration.isRedemptionActive,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.configuration,
                                  "isRedemptionActive",
                                  $$v
                                )
                              },
                              expression: "configuration.isRedemptionActive",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.configuration.isActive
                ? [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-global_cashback_percentage",
                                type: "number",
                                label: _vm.$t(
                                  "Percentual Global de Cashback (%)"
                                ),
                                step: 0.01,
                                min: 0,
                                max: 100,
                                validation: "required|min:0|max:100",
                                "validation-behavior": "live",
                              },
                              model: {
                                value:
                                  _vm.configuration.globalCashbackPercentage,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "globalCashbackPercentage",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.globalCashbackPercentage",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-global_credit_validity_days",
                                type: "number",
                                label: _vm.$t("Validade dos Créditos (dias)"),
                                min: 1,
                                validation: "required|min:1",
                                "validation-behavior": "live",
                              },
                              model: {
                                value:
                                  _vm.configuration.globalCreditValidityDays,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "globalCreditValidityDays",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.globalCreditValidityDays",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-global_credit_usage_limit_percentage",
                                type: "number",
                                label: _vm.$t(
                                  "Limite Global de Uso por Venda (%)"
                                ),
                                help: _vm.$t(
                                  "Percentual máximo do valor da venda que pode ser pago com ecash. Vale para as tabelas de preço sem configuração própria abaixo."
                                ),
                                step: 0.01,
                                min: 0,
                                max: 100,
                                validation: "required|min:0|max:100",
                                "validation-behavior": "live",
                              },
                              model: {
                                value:
                                  _vm.configuration
                                    .globalCreditUsageLimitPercentage,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "globalCreditUsageLimitPercentage",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.globalCreditUsageLimitPercentage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false",
                              },
                            ],
                            attrs: { md: "6" },
                          },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-minimum_purchase_value",
                                type: "text-number",
                                currency: "R$",
                                precision: 2,
                                validation: "optional|min:1",
                                label: _vm.$t("Valor Mínimo de Compra"),
                                help: _vm.$t(
                                  "Deixe em branco para não ter valor mínimo"
                                ),
                              },
                              model: {
                                value: _vm.configuration.minimumPurchaseValue,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "minimumPurchaseValue",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.minimumPurchaseValue",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-require_app_registration",
                                type: "switch",
                                label: _vm.$t("Exigir cadastro no app?"),
                                instruction: _vm.$t(
                                  "Quando habilitado, o cliente deve estar cadastrado no aplicativo para receber recompensas"
                                ),
                              },
                              model: {
                                value: _vm.configuration.requireAppRegistration,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "requireAppRegistration",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.requireAppRegistration",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-enabled_sale_classifications",
                                type: "vue-select",
                                label: _vm.$t(
                                  "Classificações de Venda Habilitadas"
                                ),
                                options: _vm.saleClassificationOptions,
                                multiple: true,
                                clearable: false,
                                placeholder: _vm.$t(
                                  "Selecione as classificações"
                                ),
                                validation: "required",
                                "validation-behavior": "live",
                              },
                              model: {
                                value:
                                  _vm.configuration.enabledSaleClassifications,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "enabledSaleClassifications",
                                    $$v
                                  )
                                },
                                expression:
                                  "configuration.enabledSaleClassifications",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("Regulamento e Termos de Uso"))
                            ),
                          ]),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "Configure os termos e condições do programa de recompensas"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-terms_version",
                                type: "text",
                                label: _vm.$t("Versão do Regulamento"),
                                placeholder: _vm.$t("Ex: 1.0, 2.1, etc."),
                                validation: "required|max:15",
                                "validation-behavior": "live",
                                help: _vm.$t("Máximo 15 caracteres"),
                              },
                              model: {
                                value: _vm.configuration.termsVersion,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "termsVersion",
                                    $$v
                                  )
                                },
                                expression: "configuration.termsVersion",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "reward_config-terms_and_conditions",
                                type: "rich-editor",
                                label: _vm.$t("Termos e Condições"),
                                placeholder: _vm.$t(
                                  "Digite aqui o regulamento completo do programa de recompensas..."
                                ),
                                validation: "required",
                                "validation-behavior": "live",
                                help: _vm.$t(
                                  "Este texto será exibido para os usuários ao fazer opt-in no programa"
                                ),
                              },
                              model: {
                                value: _vm.configuration.termsAndConditions,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.configuration,
                                    "termsAndConditions",
                                    $$v
                                  )
                                },
                                expression: "configuration.termsAndConditions",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Configurações por Tabela de Preço")
                              )
                            ),
                          ]),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "Configure percentuais específicos para cada tabela de preço"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.configuration.priceTableSettings,
                      function (setting, index) {
                        return _c(
                          "b-row",
                          { key: setting.priceTableId, staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "price_table_" + index,
                                    type: "vue-select",
                                    label:
                                      index === 0
                                        ? _vm.$t("Tabela de Preço")
                                        : "",
                                    options: _vm.getComboPriceTables,
                                    clearable: false,
                                    placeholder: _vm.$t("Selecione"),
                                    validation: "required",
                                    "validation-behavior": "live",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onPriceTableChange(
                                        index,
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: setting.priceTableId,
                                    callback: function ($$v) {
                                      _vm.$set(setting, "priceTableId", $$v)
                                    },
                                    expression: "setting.priceTableId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "cashback_percentage_" + index,
                                    type: "number",
                                    label:
                                      index === 0 ? _vm.$t("Cashback (%)") : "",
                                    step: 0.01,
                                    min: 0,
                                    max: 100,
                                    validation: "required|min:0|max:100",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: setting.cashbackPercentage,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        setting,
                                        "cashbackPercentage",
                                        $$v
                                      )
                                    },
                                    expression: "setting.cashbackPercentage",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "credit_validity_days_" + index,
                                    type: "number",
                                    label:
                                      index === 0
                                        ? _vm.$t("Validade (dias)")
                                        : "",
                                    min: 1,
                                    validation: "required|min:1",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: setting.creditValidityDays,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        setting,
                                        "creditValidityDays",
                                        $$v
                                      )
                                    },
                                    expression: "setting.creditValidityDays",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id:
                                      "credit_usage_limit_percentage_" + index,
                                    type: "number",
                                    label:
                                      index === 0
                                        ? _vm.$t("Limite de Uso por Venda (%)")
                                        : "",
                                    step: 0.01,
                                    min: 0,
                                    max: 100,
                                    validation: "required|min:0|max:100",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: setting.creditUsageLimitPercentage,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        setting,
                                        "creditUsageLimitPercentage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "setting.creditUsageLimitPercentage",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("b-col", { attrs: { md: "2" } }, [
                              _c(
                                "div",
                                { class: { "mt-4": index === 0 } },
                                [
                                  _c("e-button", {
                                    attrs: {
                                      id: "remove_price_table_" + index,
                                      type: "button",
                                      variant: "outline-danger",
                                      icon: "trash-2",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removePriceTableSetting(
                                          index
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("e-button", {
                              attrs: {
                                id: "add_price_table_setting",
                                type: "button",
                                variant: "outline-primary",
                                icon: "plus",
                                text: _vm.$t("Adicionar Tabela de Preço"),
                              },
                              on: { click: _vm.addPriceTableSetting },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("Períodos Especiais"))),
                          ]),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "Configure períodos específicos com cashback diferenciado"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.configuration.specialPeriods,
                      function (period, index) {
                        return _c(
                          "b-row",
                          { key: "period_" + index, staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "period_day_" + index,
                                    type: "vue-select",
                                    label:
                                      index === 0
                                        ? _vm.$t("Dia da Semana")
                                        : "",
                                    options: _vm.dayOfWeekOptions,
                                    clearable: false,
                                    placeholder: _vm.$t("Selecione"),
                                    validation: "required",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: period.dayOfWeek,
                                    callback: function ($$v) {
                                      _vm.$set(period, "dayOfWeek", $$v)
                                    },
                                    expression: "period.dayOfWeek",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "period_start_" + index,
                                    type: "time",
                                    label:
                                      index === 0
                                        ? _vm.$t("Horário Início")
                                        : "",
                                    validation: "required",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: period.startTime,
                                    callback: function ($$v) {
                                      _vm.$set(period, "startTime", $$v)
                                    },
                                    expression: "period.startTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "period_end_" + index,
                                    type: "time",
                                    label:
                                      index === 0 ? _vm.$t("Horário Fim") : "",
                                    validation: "required",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: period.endTime,
                                    callback: function ($$v) {
                                      _vm.$set(period, "endTime", $$v)
                                    },
                                    expression: "period.endTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "period_cashback_" + index,
                                    type: "number",
                                    label:
                                      index === 0 ? _vm.$t("Cashback (%)") : "",
                                    step: 0.01,
                                    min: 0,
                                    max: 100,
                                    validation: "required|min:0|max:100",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: period.cashbackPercentage,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        period,
                                        "cashbackPercentage",
                                        $$v
                                      )
                                    },
                                    expression: "period.cashbackPercentage",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "period_description_" + index,
                                    type: "text",
                                    label:
                                      index === 0 ? _vm.$t("Descrição") : "",
                                    placeholder: _vm.$t("Ex: Happy Hour"),
                                  },
                                  model: {
                                    value: period.description,
                                    callback: function ($$v) {
                                      _vm.$set(period, "description", $$v)
                                    },
                                    expression: "period.description",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "1" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "period_active_" + index,
                                    type: "switch",
                                    label: index === 0 ? _vm.$t("Ativo") : "",
                                  },
                                  model: {
                                    value: period.isActive,
                                    callback: function ($$v) {
                                      _vm.$set(period, "isActive", $$v)
                                    },
                                    expression: "period.isActive",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("b-col", { attrs: { md: "1" } }, [
                              _c(
                                "div",
                                { class: { "mt-4": index === 0 } },
                                [
                                  _c("e-button", {
                                    attrs: {
                                      id: "remove_period_" + index,
                                      type: "button",
                                      variant: "outline-danger",
                                      icon: "trash-2",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeSpecialPeriod(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("e-button", {
                              attrs: {
                                id: "add_special_period",
                                type: "button",
                                variant: "outline-primary",
                                icon: "plus",
                                text: _vm.$t("Adicionar Período Especial"),
                              },
                              on: { click: _vm.addSpecialPeriod },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("Produtos Especiais"))),
                          ]),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "Configure produtos específicos com cashback adicional"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.configuration.specialProducts,
                      function (product, index) {
                        return _c(
                          "b-row",
                          { key: "product_" + index, staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c("e-search-sku", {
                                  attrs: {
                                    id: "product_id_" + index,
                                    "value-is-object": "",
                                    "is-credit-kit": false,
                                    autofocus: "",
                                  },
                                  model: {
                                    value: product.sku,
                                    callback: function ($$v) {
                                      _vm.$set(product, "sku", $$v)
                                    },
                                    expression: "product.sku",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "product_quantity_" + index,
                                    type: "number",
                                    label:
                                      index === 0 ? _vm.$t("Qtd Mínima") : "",
                                    step: 0.001,
                                    min: 0,
                                    placeholder: _vm.$t("Opcional"),
                                  },
                                  model: {
                                    value: product.minimumPurchaseQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        product,
                                        "minimumPurchaseQuantity",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "product.minimumPurchaseQuantity",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "product_cashback_" + index,
                                    type: "number",
                                    label:
                                      index === 0 ? _vm.$t("Cashback (%)") : "",
                                    step: 0.01,
                                    min: 0,
                                    max: 100,
                                    validation: "required|min:0|max:100",
                                    "validation-behavior": "live",
                                  },
                                  model: {
                                    value: product.cashbackPercentage,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        product,
                                        "cashbackPercentage",
                                        $$v
                                      )
                                    },
                                    expression: "product.cashbackPercentage",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "product_start_" + index,
                                    type: "date",
                                    label:
                                      index === 0 ? _vm.$t("Data Início") : "",
                                    placeholder: _vm.$t("Opcional"),
                                  },
                                  model: {
                                    value: product.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(product, "startDate", $$v)
                                    },
                                    expression: "product.startDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "product_end_" + index,
                                    type: "date",
                                    label:
                                      index === 0 ? _vm.$t("Data Fim") : "",
                                    placeholder: _vm.$t("Opcional"),
                                  },
                                  model: {
                                    value: product.endDate,
                                    callback: function ($$v) {
                                      _vm.$set(product, "endDate", $$v)
                                    },
                                    expression: "product.endDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "1" } },
                              [
                                _c("FormulateInput", {
                                  attrs: {
                                    id: "product_active_" + index,
                                    type: "switch",
                                    label: index === 0 ? _vm.$t("Ativo") : "",
                                  },
                                  model: {
                                    value: product.isActive,
                                    callback: function ($$v) {
                                      _vm.$set(product, "isActive", $$v)
                                    },
                                    expression: "product.isActive",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("b-col", { attrs: { md: "1" } }, [
                              _c(
                                "div",
                                { class: { "mt-4": index === 0 } },
                                [
                                  _c("e-button", {
                                    attrs: {
                                      id: "remove_product_" + index,
                                      type: "button",
                                      variant: "outline-danger",
                                      icon: "trash-2",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeSpecialProduct(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c("e-button", {
                              attrs: {
                                id: "add_special_product",
                                type: "button",
                                variant: "outline-primary",
                                icon: "plus",
                                text: _vm.$t("Adicionar Produto Especial"),
                              },
                              on: { click: _vm.addSpecialProduct },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12", align: "right" } },
                    [
                      _c("e-button", {
                        staticClass: "mr-2",
                        attrs: {
                          id: "cancel_reward_config",
                          type: "button",
                          variant: "outline-secondary",
                          icon: "x",
                          text: _vm.$t("Cancelar"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.go(-1)
                          },
                        },
                      }),
                      _c("e-button", {
                        attrs: {
                          id: "save_reward_config",
                          type: "submit",
                          variant: "primary",
                          icon: "save",
                          text: _vm.$t("Salvar"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }